















































































import Vue from 'vue'
import statisticsList from "@/assets/json/statisticsList.json";
import { ImagePreview } from 'vant';

export default Vue.extend({
  props: ['barId', 'mapData', 'mapUnit', 'subId'],
  watch: {
    barId(value) {
      this.type = value

    },
    mapData(value) {
      this.dataList = value
      this.minStation = undefined
      this.maxStation = undefined
      this.statistics()
    }
  },
  data() {
    return {
      dataList: [] as any,
      type: '',
      minStation: undefined,
      maxStation: undefined,
      preStationCount: 0,
      detailData: [],
      windLevel: '',
    }
  },
  created() {
    this.dataList = this.mapData
    this.type = this.barId
    this.statistics()
  },
  methods: {
    statistics() {
      if (this.dataList && this.dataList.length > 0) {
        //最高
        this.maxStation = this.sortDown()[0]
        //最低
        if (this.type === 'tem' || this.type === 'rhu' || this.type === 'prs') {
          this.minStation = this.sortUp()[0]
        }

        if (this.type === 'pre') {
          this.preStationCount = this.dataList.filter((e: any) => e.value > 0).length
          if (this.preStationCount === 0) {
            this.maxStation = undefined
          }

          this.detailStat(this.subId)
        }
        if (this.type === 'wind') {
          this.detailStat(this.barId)
        }

      } else {
        this.minStation = undefined
        this.maxStation = undefined
        this.preStationCount = 0
        this.detailData = []
      }
    },


    detailStat(type: any) {
      if (type === 'pre_0808' || type === 'pre_2020') {
        type = 'pre_any'
      }
      // @ts-ignore
      const detailStatJson = statisticsList[type].data
      const showDetailStatJson = detailStatJson.filter((e: any) => { return e.show === true })
      showDetailStatJson.forEach((e: any) => {
        const minValue = e.value[0]
        const maxValue = e.value[1]
        let count = 0
        this.dataList.forEach((data: any) => {
          let value = data.value
          if (this.type === 'wind') {
            value = data.level
          }
          if (value >= minValue && value <= maxValue) {
            count++
          }
        })
        e.count = count
      });
      this.detailData = showDetailStatJson
    },
    showTips() {
      const images = ['/static/image/wind_desc.png']
      ImagePreview({
        images,
        startPosition: 0,
        closeable:true
      });
    },

    sortUp() {
      const arrNew = JSON.parse(JSON.stringify(this.mapData))
      const arrData = this.getChartSort(arrNew, 'value')
      return arrData

    },
    sortDown() {
      const arrNew = JSON.parse(JSON.stringify(this.mapData))
      const arrData = this.getChartSort(arrNew, 'value').reverse()
      return arrData
    },
    getChartSort(json: any, key: any) {
      for (let j = 1, jl = json.length; j < jl; j++) {
        const temp = json[j]
        const val = temp[key]
        let i = j - 1;
        while (i >= 0 && json[i][key] > val) {
          json[i + 1] = json[i];
          i = i - 1;
        }
        json[i + 1] = temp;
      }
      return json;
    },
  },
})
